import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faDatabase,
    faBell,
    faQuestionCircle,
    faFolderOpen,
    faCog,
    faChartLine,
    faMessage,
    faFolderMinus,
    faUserCircle,
    faArrowRight,
    faArrowLeft,
    faListSquares,
    faBook,
    faUserFriends,
    faNewspaper,
} from "@fortawesome/free-solid-svg-icons";
import { Accordion } from "react-bootstrap";
import "./Sidebar.scss";
import { useNavigate } from "react-router-dom";
// import { ReactComponent as Logo } from "../../Assets/svg/dm_logo.svg";
import LogoExpanded from "../../Assets/img/mars-logo.png";
import LogoCollapsed from "../../Assets/img/mars-icon.png";
import { Dropdown } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";

const Sidebar = () => {
    const [expanded, setExpanded] = useState(false);
    const [active, setActive] = useState("home");
    const navigate = useNavigate();
    const { instance } = useMsal();
    let activeAccount;

    if (instance) {
        activeAccount = instance.getActiveAccount();
    }

    const handleExpandedToggle = () => setExpanded(!expanded);
    const handleNavigateTo = (route) => navigate(route);

    return (
        <div className={`sidebar ${expanded ? "expanded" : ""}`}>
            {/* Logo Section */}
            <div
                className={`sidebar-item brand ${active === "brand" ? "active" : ""}`}
                onClick={() => handleExpandedToggle()}
            >
                {expanded ? <img src={LogoExpanded} alt="Logo" className="brand-expanded" /> : <img src={LogoCollapsed} alt="Logo" className="brand-collapsed" />}
            </div>

            {/* User Section */}
            <div className={`user-item ${expanded ? "expanded" : ""}`}>
                <FontAwesomeIcon icon={faUserCircle} className="text-primary" />
                {expanded && (
                    <div className="user-info">
                        <div className="user-info-text d-flex flex-column align-items-start">
                            <p className="fw-bold m-0">{activeAccount && activeAccount.name}</p>
                            <p className="small fw-normal text-secondary-emphasis m-0">
                                {activeAccount && activeAccount.username.split("@")[0]}
                            </p>
                        </div>
                        <Dropdown align="end">
                            <Dropdown.Toggle variant="transparent" id="dropdown-profile" />
                            <Dropdown.Menu>
                                <Dropdown.Item as="button">Sign out</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )}
            </div>

            {/* Action Items */}
            <div className="action-items">
                <Accordion flush alwaysOpen className="d-flex flex-column justify-content-between h-100">
                    <div className="top-items">
                        <div
                            className={`sidebar-item ${active === "home" ? "active" : ""}`}
                            onClick={() => handleNavigateTo("/home")}
                        >
                            <FontAwesomeIcon icon={faHome} />
                            {/* <SmartCPGIcon name="home" /> */}
                            {expanded && <span>Home</span>}
                        </div>
                        <div
                            className={`sidebar-item ${active === "news" ? "active" : ""}`}
                            onClick={() => handleNavigateTo("/news")}
                        >
                            <FontAwesomeIcon icon={faNewspaper} />
                            {expanded && <span>News</span>}
                        </div>
                        <div
                            className={`sidebar-item ${active === "dashboards" ? "active" : ""}`}
                            onClick={() => handleNavigateTo("/dashboards")}
                        >
                            <FontAwesomeIcon icon={faChartLine} />
                            {expanded && <span>Dashboards</span>}
                        </div>
                        <Accordion.Item eventKey="data">
                            <Accordion.Header onClick={() => setExpanded(true)}>
                                <div
                                    className={`sidebar-item ${active === "data" ? "active" : ""}`}
                                >
                                    <FontAwesomeIcon icon={faDatabase} />
                                    {expanded && <span>Data Management</span>}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/data-extraction")}
                                >
                                    Export to CSV
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/extraction-templates")}
                                >
                                    Extraction Templates
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/scheduled-tasks")}
                                >
                                    Scheduled Tasks Monitor
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/docs/api/v1")}
                                >
                                    API Connection
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="files">
                            <Accordion.Header onClick={() => setExpanded(true)}>
                                <div
                                    className={`sidebar-item ${active === "docu-chat" ? "active" : ""}`}
                                >
                                    <FontAwesomeIcon icon={faFolderMinus} />
                                    {expanded && <span>Files</span>}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div 
                                    className="submenu-item" 
                                    onClick={() => handleNavigateTo('/files')}
                                >
                                    My Documents
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/chat-files")}
                                >
                                    Chat Files
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="agent">
                            <Accordion.Header onClick={() => setExpanded(true)}>
                                <div
                                    className={`sidebar-item ${active === "agent" ? "active" : ""}`}
                                >
                                    <FontAwesomeIcon icon={faUserFriends} />
                                    {expanded && <span>Agent</span>}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/chat")}
                                >
                                    Chat
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/docu-chat")}
                                >
                                    DocuChat
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="catalogs">
                            <Accordion.Header onClick={() => setExpanded(true)}>
                                <div
                                    className={`sidebar-item ${active === "catalogs" ? "active" : ""}`}
                                >
                                    <FontAwesomeIcon icon={faBook} />
                                    {expanded && <span>Catalogs</span>}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/product-catalog")}
                                >
                                    Products
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/store-catalog")}
                                >
                                    Stores
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </div>
                    <div className="bottom-items">
                        <Accordion.Item eventKey="admin">
                            <Accordion.Header onClick={() => setExpanded(true)}>
                                <div
                                    className={`sidebar-item ${active === "admin" ? "active" : ""}`}
                                >
                                    <FontAwesomeIcon icon={faCog} />
                                    {expanded && <span>Admin</span>}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/admin-notifications")}
                                >
                                    Notifications
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/support")}
                                >
                                    Tickets
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/admin-news")}
                                >
                                    News
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/admin-config")}
                                >
                                    Admin
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <div
                            className={`sidebar-item ${active === "notifications" ? "active" : ""}`}
                            onClick={() => handleNavigateTo("/notifications")}
                        >
                            <FontAwesomeIcon icon={faBell} />
                            {expanded && <span>Notifications</span>}
                        </div>
                        <div
                            className={`sidebar-item ${active === "help" ? "active" : ""}`}
                            onClick={() => handleNavigateTo("/help")}
                        >
                            <FontAwesomeIcon icon={faQuestionCircle} />
                            {expanded && <span>Help</span>}
                        </div>
                    </div>
                </Accordion>
            </div>

            {/* Toggle Button */}
            <div
                className="sidebar-item"
                onClick={() => handleExpandedToggle()}
            >
                <FontAwesomeIcon icon={expanded ? faArrowLeft : faArrowRight} />
                {expanded && <span>Collapse</span>}
            </div>
        </div>
    );
};

export default Sidebar;
